import * as client from "../../client";

// Return a stable, comparable key for sorting ReportContact,
// with support for a company_info fallback.
export const brokerSortValue = (
  contact: client.ReportContact | null | undefined,
  company_info: client.RawCompanyInfo
): string => {
  if (!contact) {
    return (company_info.broker_name ?? "").toLowerCase();
  }
  return (
    contact.full_name ||
    contact.organization_name ||
    contact.email ||
    company_info.broker_name ||
    ""
  ).toLowerCase();
};

export const getPolicySourceNames = (
  sublimitInfo: client.SublimitInfo | null | undefined,
  deductibleInfo: client.AdvancedDeductibleInfo | null | undefined,
  limitInfo: client.AdvancedLimitInfo | null | undefined
): string[] => [
  ...new Set([
    ...Object.keys(sublimitInfo?.extracted_sublimits ?? {}),
    ...Object.keys(deductibleInfo?.extracted_deductibles ?? {}),
    ...Object.keys(limitInfo?.extracted_limits ?? {}),
  ]),
];
